import { createReducer } from 'typesafe-actions';
import {
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_ERROR,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_MY_ENTERPRISE,
  GET_MY_ENTERPRISE_ERROR,
  GET_MY_ENTERPRISE_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_ERROR,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_ADMIN,
  REGISTER_ADMIN_ERROR,
  REGISTER_ADMIN_SUCCESS,
  REGISTER_MEMBER,
  REGISTER_MEMBER_ERROR,
  REGISTER_MEMBER_SUCCESS,
  REGISTER_USER,
  REGISTER_USER_AND_ENTERPRISE,
  REGISTER_USER_AND_ENTERPRISE_ERROR,
  REGISTER_USER_AND_ENTERPRISE_SUCCESS,
  REGISTER_USER_ERROR,
  REGISTER_USER_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
} from './actions';
import { AuthAction, AuthState } from './types';

const initialState: AuthState = {
  auth: {
    loading: false,
    data: null,
    error: null,
  },
  myEnterprise: {
    loading: false,
    data: null,
    error: null,
  },
  isLoggedIn: false,
};

const Auth = createReducer<AuthState, AuthAction>(initialState, {
  [UPDATE_USER]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [UPDATE_USER_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [UPDATE_USER_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [REGISTER_USER]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [REGISTER_USER_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [REGISTER_USER_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [REGISTER_USER_AND_ENTERPRISE]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [REGISTER_USER_AND_ENTERPRISE_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [REGISTER_USER_AND_ENTERPRISE_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [LOGIN_USER]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [LOGIN_USER_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [LOGIN_USER_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [GET_LOGGED_IN_USER]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_LOGGED_IN_USER_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [GET_LOGGED_IN_USER_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      /**
       * 로그인 되지 않은 상태에서 페이지 접속할 경우
       * 로그인 페이지로 리다이렉트 된 후 에러 메시지 출력됨
       * user 데이터 리프레쉬 할 경우 에러 메시지 무시하도록 함
       */
      error: null,
      // error: action.payload,
      data: null,
    },
  }),

  [LOGOUT_USER]: (state) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: null,
    },
    isLoggedIn: false,
  }),

  [GET_MY_ENTERPRISE]: (state) => ({
    ...state,
    myEnterprise: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_MY_ENTERPRISE_SUCCESS]: (state, action) => ({
    ...state,
    myEnterprise: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [GET_MY_ENTERPRISE_ERROR]: (state, action) => ({
    ...state,
    myEnterprise: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [REGISTER_MEMBER]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [REGISTER_MEMBER_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [REGISTER_MEMBER_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [REGISTER_ADMIN]: (state) => ({
    ...state,
    auth: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [REGISTER_ADMIN_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: null,
      data: action.payload,
    },
    isLoggedIn: true,
  }),
  [REGISTER_ADMIN_ERROR]: (state, action) => ({
    ...state,
    auth: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),
});

export default Auth;
